<template lang="pug">
app-editable-content.pa-3(
  ref="container"
  :show-buttons="isEditable"
  :loading="loading"
  :vertical="true"
  @accept="acceptName"
  @reject="rejectName"
)
  template(#default="{ isEditing }")
    template(v-if="isEditing")
      v-textarea.name-editor__title.pb-6.font-weight-bold.overflow-y-auto(
        v-model="name"
        auto-grow
        solo
        flat
        hide-details
        rows="1"
        full-width
        :class="nameClasses"
        :style="`--max-height: ${maxHeight}px;`"
        :placeholder="placeholer"
        :rules="[rules.max(maxSymbols)]"
      )
      .redesignDisabledText--text.font-weight-light.text-center(
        :class=`{
          'body-2': $vuetify.breakpoint.smAndDown,
          'body-1': $vuetify.breakpoint.mdAndUp,
        }`
      ) {{ name.length }}/{{ maxSymbols }}
    .name-editor__title.font-weight-bold.text-center.word-break(
      v-else
      :class="nameClassesTitle"
      :style="`color: ${styledColor};`"
      @click="editName"
    ) {{ name || placeholer }}
</template>

<script>
import AppEditableContent from '@/components/user-redesign/AppEditableContent.vue';
import rules from '@/helpers/rules';

const MAX_NAME_LENGTH = 256;

export default {
  components: {
    AppEditableContent,
  },

  props: {
    value: { type: String, default: '' },
    defaultName: { type: String, default: '' },
    maxSymbols: { type: Number, default: MAX_NAME_LENGTH },
    placeholer: { type: String, default: 'Название мероприятия' },
    loading: { type: Boolean, default: false },
    styledColor: { type: String, default: '' },
    isEditable: { type: Boolean, default: false },
    largeClass: { type: String, default: 'display-3' },
    mediumClass: { type: String, default: 'display-2' },
    smallClass: { type: String, default: 'display-1' },
    maxHeight: { type: Number, default: 500 },
    lineClamp: { type: Number, default: 5 },
    maxNameLength: { type: Number, default: null },
  },

  data() {
    return {
      rules,
    };
  },

  computed: {
    name: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    nameClasses() {
      const { xs, sm, mdAndUp } = this.$vuetify.breakpoint;
      const { maxNameLength, name } = this;
      return [
        ...(!name.length ? ['redesignDisabledText--text'] : []),
        ...(maxNameLength && name.length > maxNameLength ?
          [this.smallClass] : [
            ...(xs ? [this.smallClass] : []),
            ...(sm ? [this.mediumClass] : []),
            ...(mdAndUp ? [this.largeClass] : []),
          ]
        ),
      ];
    },
    nameClassesTitle() {
      return [
        ...this.nameClasses,
        `line-clamp-${this.lineClamp}`,
        ...(this.isEditable ? ['pointer'] : []),
      ];
    },
  },

  methods: {
    acceptName() {
      if (!this.name.length || this.name.length > this.maxSymbols) {
        this.rejectName();
        return;
      }
      if (this.name === this.defaultName) return;
      this.$emit('update', this.name);
    },
    rejectName() {
      this.name = this.defaultName;
    },

    editName() {
      if (!this.isEditable) return;
      const switchEditing = this.$refs?.container?.switchEditingMode;
      if (switchEditing && typeof switchEditing === 'function') switchEditing();
    },
  },
};
</script>

<style lang="scss" scoped>
.name-editor {
  &__title,
  &__title::v-deep textarea {
    max-width: 1200px;
    text-align: center;
    line-height: normal;
  }
  &__title.v-textarea {
    max-height: var(--max-height);
  }
}
</style>
